export const environment = {
  production: true,
  buildId: '2644082324918131',
  configFile: 'config.json',
};
